import { useEffect, useRef, useState } from "react";
import { useModal } from "../../context/ModalContext";
import { useFileNavigator } from "../../context/FileNavigator";
import { getButtonsCancelOk } from "../../context/helpers/helperModalContext";
import * as apiFN from "../../api/apiFileNavigator";
import { useTranslation } from "react-i18next";
import { useToast } from "../../context/ToastContext";
import { handleInputFileName } from "../../utils/helpers/handleInputMaks";

const CreateFolder = ({ showCreateFolderDlg, setShowCreateFolderDlg }) => {
    const { t } = useTranslation(['FileNavigator', 'common']);
    const { showDlg, hideDlg } = useModal();
    const { stateFN, dispatchFN, fetchDataFN } = useFileNavigator();

    const { showToast } = useToast();
    const refInputNewFolder = useRef();
    const refFormNewFolder = useRef();
  
    // JSX форми діалогу створення папки
    const htmlModel = (
        <form ref={refFormNewFolder}
            onSubmit={(e) => handleSubmitCreateFolder(e)}>
            <div className="mb-3">
            <label className="form-label" >
                {t('newFolderName')}
            </label>
            <input type="text" 
                ref={refInputNewFolder}
                defaultValue=""
                className="form-control"
                onInput={()=>handleInputFileName(refInputNewFolder)}
                required />
            <small id="emailHelp" className="form-text text-muted">
                {t('createIn')}: {`Root${stateFN.currentPathFN}`}
            </small>
            </div>
        </form>
    ); 

    // Параметри кнопок діалогу створення папки
    const paramsCreateDlg = {
        title: t('popupCreateFolder'),
        buttons: [...getButtonsCancelOk(t)],
        type: "confirm",
        text: htmlModel,
        refFirstFocus: refInputNewFolder
    };

    // Подія субміту на кнопку ОК
    paramsCreateDlg.buttons[1].handleClick = () => {
        refFormNewFolder.current.requestSubmit();
    }
 
    // Створення папки - подія submit форми діалогу
    const handleSubmitCreateFolder = (e) => {
        e.preventDefault();
        hideDlg(false)
        createFolder();
    }

    const createFolder = async () => {
        dispatchFN({type:'SET_DATA_FN', payload:null});
        const createFolderData = {
            currentPath : stateFN.currentPathFN,
            folderName  : refInputNewFolder.current.value
        }

        const resCreate = await apiFN.createFolder(createFolderData);
        
        (resCreate)
            ? showToast(t('messFolderCreate'), 'success')
            : showToast(t('common:messError'), 'danger');

        fetchDataFN(true);
    }

    useEffect(() => {
        // Показуємо діалог якщо showCreateFolderDlg
        // та скидаємо showCreateFolderDlg
        if (showCreateFolderDlg === true) {
            showDlg(paramsCreateDlg);
            setShowCreateFolderDlg(false);
        }
    }, [showCreateFolderDlg]);

    return <></>;
};

export default CreateFolder;
